import { aspectRatioToFraction } from './aspectRatioToFraction';
import qs from 'qs';
export function getSrcWithParams(width, aspect, src, includeViewportSize = true, options = { crop: false }) {
    const resizeMethod = options.crop ? 'crop' : 'fit';
    const gravity = options.gravity;
    const quality = options.quality;
    const height = aspect
        ? Math.round(width * aspectRatioToFraction(aspect))
        : null;
    const commonOptions = {
        extend: 'copy',
        width,
        quality
    };
    const qstring = height
        ? qs.stringify(Object.assign({}, commonOptions, { method: resizeMethod, height,
            gravity }), {
            addQueryPrefix: true
        })
        : qs.stringify(Object.assign({}, commonOptions, { method: 'thumbnail' }), {
            addQueryPrefix: true
        });
    return src + qstring + `${includeViewportSize ? ` ${width}w` : ''}`;
}
//# sourceMappingURL=getSrcWithParams.js.map